module.exports = __webpack_public_path__ + "img/service.a8e0c35a.png";